import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { getProductTypeDeliveries } from '../../../utils/get-product-types-deliveries.js';
import { useDeliveryIndicator } from '../../../contexts/DeliveryIndicator/context.js';
import { getDeliveryEstimation } from '../../../utils/get-delivery-estimation.js';
import { DeliveryIndicator } from '../components/DeliveryIndicator.js';
import { DeliveryIndicatorTooltip } from '../components/DeliveryIndicatorTooltip.js';
import { defaultDeliveryResolver } from '../../../utils/default-delivery-resolver.js';

var DeliveryIndicatorBasicContainer = (_param)=>{
    var { view ='full' , fallbackLabel , availability =[] , deliveryResolver =defaultDeliveryResolver , productTypes  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "view",
        "fallbackLabel",
        "availability",
        "deliveryResolver",
        "productTypes"
    ]);
    var ref;
    const { getLabel , getFormattedLabel  } = useIntl();
    const { config  } = useDeliveryIndicator();
    // Can't render without availability and fallback label
    if ((availability === null || availability === void 0 ? void 0 : availability.length) === 0 && (!productTypes || productTypes.size < 1) && !fallbackLabel) {
        return null;
    }
    let deliveries = [];
    if (productTypes && productTypes.size && config.productTypeDeliveryConfig) {
        deliveries = getProductTypeDeliveries(productTypes, config.productTypeDeliveryConfig) || deliveryResolver(config, availability);
    } else {
        deliveries = deliveryResolver(config, availability);
    }
    const deliveryEstimation = getDeliveryEstimation(deliveries, config === null || config === void 0 ? void 0 : (ref = config.missingInventoryChannelStrategy) === null || ref === void 0 ? void 0 : ref.expectedDeliveryDays) || '';
    const isNextDayDelivery = deliveryEstimation === '1';
    const labels = {
        deliveryIndication: getFormattedLabel('products.deliveryIndicator.shortDeliveryIndication', {
            labelData: {
                days: deliveryEstimation
            }
        })
    };
    let message = fallbackLabel || '';
    if (availability.length) {
        if (config.nextDayDeliveryTimeLimit && isNextDayDelivery) {
            message = `${getFormattedLabel('products.deliveryIndicator.deliveryNextDay', {
                labelData: {
                    timeLimit: config.nextDayDeliveryTimeLimit
                }
            })}`;
        } else if (deliveryEstimation) {
            message = `${getFormattedLabel('products.deliveryIndicator.deliveryIndication', {
                labelData: {
                    days: deliveryEstimation
                }
            })}`;
        }
    }
    return /*#__PURE__*/ React.createElement(DeliveryIndicator, swcHelpers.extends({
        view: view,
        labels: labels,
        deliveryMessage: message,
        tooltipSlot: /*#__PURE__*/ React.createElement(DeliveryIndicatorTooltip, {
            message: getLabel('products.deliveryIndicator.deliveryTooltip'),
            view: view
        })
    }, rest));
};

export { DeliveryIndicatorBasicContainer };
//# sourceMappingURL=DeliveryIndicatorBasic.js.map
